import React from 'react';

import { LoginCard } from '@/components/organisms/Auth';
import { LoginLayout } from '@/components/templates/LoginLayout';
import { CmBox, CmHeading, CmText } from '@/components/uiParts';
import { Form } from '@/pages/registration/components/Form';
import { routes } from '@/router';

import { useRegistration } from './hooks/useRegistration';

const RegistrationPage = (): JSX.Element => {
  const registration = useRegistration();

  return (
    <LoginLayout>
      <LoginCard>
        <CmHeading size="md" fontSize="2xl" mb={5}>
          {routes.Registration.title}
        </CmHeading>
        <CmBox mb={8}>
          <CmText>お客様のアカウントは現在仮登録中です。</CmText>
          <CmText>本登録のためには以下でパスワードを設定してください。</CmText>
        </CmBox>
        <Form onSubmit={registration} />
      </LoginCard>
    </LoginLayout>
  );
};

export default RegistrationPage;
